import styled from 'styled-components';
import MuiAlert from '../../Alert';
export var Alert = styled(MuiAlert).withConfig({
  displayName: "style__Alert",
  componentId: "sc-1ngqe2m-0"
})(["justify-content:center;text-align:left;"]);